import * as http from '../http'
import * as TYPES from './types'

export default class TagsGateway {
  getTag (params = {}) {
    return http.GET(TYPES.GET_TAG_ENDPOINT, params)
  }

  getTags () {
    return http.GET(TYPES.GET_TAGS_ENDPOINT)
  }

  getDeletedTags () {
    return http.GET(TYPES.DELETED_TAGS)
  }

  getManagersByTagId (params = {}) {
    return http.GET(TYPES.GET_TAGS_MANAGERS_ENDPOINT, params)
  }

  getEmployeesByTagId (params = {}) {
    return http.GET(TYPES.GET_TAGS_EMPLOYEES_ENDPOINT, params)
  }

  addTag (query = {}) {
    return http.POST(TYPES.ADD_TAG_ENDPOINT, query)
  }

  activateTag (params = {}) {
    return http.POST(TYPES.ACTIVATE_TAG_ENDPOINT, null, params)
  }

  updateTag (query = {}) {
    return http.POST(TYPES.UPDATE_TAG_ENDPOINT, query)
  }

  deleteTag (params = {}) {
    return http.DELETE(TYPES.DELETE_TAG_ENDPOINT, params)
  }
}



// WEBPACK FOOTER //
// ./src/api/tags/TagsGateway.js